module.exports = __webpack_public_path__ + "img/電気回路_5_4.7b2d9887.png";